<script>

import { ChiRhosV3 } from "@paladin/core"
import { PaladinPropertyPresetItem, } from '@paladin/core-components'
// import PaladinPropertyPresetItem from '../../../library/components/property-preset/paladin-property-preset-item'
import Multiselect from 'vue-multiselect'

import _ from 'lodash'

const ChiRhosV3Api = new ChiRhosV3().api();

export default {
  components: { Multiselect, PaladinPropertyPresetItem },
  props: {
    activeGroup: {
      type: Object,
      required: true,
    },
    allRoles: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      newPropertyName: '',
      protectedProperties: [],
      presets: [],
    }
  },
  computed: {
  },
  watch: {
  },
  mounted: function() {
    this.$nextTick(function() {
        this.init()
    })
  },
  created: function() {
  },
  methods: {
    init()
    {
      this.protectedProperties = []

      var generateUUID = this.generateUUID
      let presets = this.presets
      let getRoleName = this.getRoleName
      // let presets = this.presets
      // let protectedProperties = this.protectedProperties

      ChiRhosV3Api.PersonApi.apiPersonProtectedPropertiesGroupListPost({ apiEntityRequest: { entityId: this.activeGroup.data.entity.entityId } }).then(
        response => {
          if(response.data)
          {
            this.protectedProperties = response.data.map(function(e) {

              var o = e.entity

              o.id = generateUUID() // temporary ID for manipulations

              if(!o.property) o.property = {}

              o.property.key = o.name

              o.read = o.readRoles ? o.readRoles.map(function(o) { return { value: o, text: getRoleName(o) } }) : []
              o.write = o.writeRoles ? o.writeRoles.map(function(o) { return { value: o, text: getRoleName(o) } }) : []

              return o
            })

            this.protectedProperties.forEach(function(prop) {
              presets.push(_.clone(prop, true))
            })
          }
        },
        error => {
          console.error(error)
          error.json().then(body => {
            this.$toast(body.Message, "error")
          })
        }
      )
    },
    addProperty()
    {
      var prop = { id: this.generateUUID(), read: [], write: [], readRoles: [], writeRoles: [], property: { key: this.newPropertyName, options: [], type: 'text', isMandatory: false, order: 0 } };

      this.protectedProperties.push(prop)
      this.presets.push(_.clone(prop, true))
    },
    updateProperty(id, ev)
    {
      var match = this.protectedProperties.find(function(element) {
        return element.id === id
      });

      if(match)
      {
        var index = this.protectedProperties.indexOf(match);

        this.protectedProperties[index].property = ev
      }
    },
    save()
    {
      // first remove any that were removed

      var updateIds = this.presets.map(o => o.id)

      var deleteIds = this.protectedProperties.map(o => o.id).filter(o => !updateIds.includes(o))

      if(deleteIds && deleteIds.length > 0)
      {
        // remove the deleted items

        let deleteKeys = this.protectedProperties.filter(o => deleteIds.includes(o.id)).map(o => o.entityId)

        let protectedProperties = this.protectedProperties

        deleteKeys.forEach(function(key) {
          ChiRhosV3Api.PersonApi.apiPersonProtectedPropertiesGroupEntityIdDelete({ entityId: key }).then(
             response => {
                 var match = protectedProperties.find(function(element) {
                  return element.entityId === key
                });

                if(match)
                {
                  var index = protectedProperties.indexOf(match);

                  protectedProperties.splice(index, 1)

                  console.log('Deleted prop with entityId: ' + key)
                }

                  console.log('Couldnt find prop with entityId: ' + key)
              },
             error => {
               console.error(error)
               error.json().then(body => {
                 this.$toast(body.Message, "error")
               })
             }
           )
        })
      }

      if(updateIds && updateIds.length > 0)
      {
        // some to update/create

        let belongsTo = this.activeGroup.data.entity.entityId
        let presets = this.presets

        this.protectedProperties.forEach(function(prop) {

          var preset = presets.find(function(element) {
            return element.id === prop.id
          });

          ChiRhosV3Api.PersonApi.apiPersonProtectedPropertiesGroupSavePost({ protectedPropertyConstruct: { entityId: prop.entityId, name: prop.property.key, property: prop.property, belongsTo: belongsTo, readRoles: preset.read.map(o => o.value), writeRoles: preset.write.map(o => o.value) } }).then(
              response => {
                if(response.data)
                {
                  console.log('Upserted prop with entity id: ' + response.data.entity.entityId)
                }
              },
              error => {
                console.error(error)
                error.json().then(body => {
                  this.$toast(body.Message, "error")
                })
              }
            )
          })

          this.$toast("Saved...", "success")
        }


      // todo

      // make sure name is set to key
      // map readRoles to read
      // map writeRoles to write



    },
    removeProperty(id)
    {
      // only remove from presets - we will compare to the original on save

      var match = this.presets.find(function(element) {
        return element.id === id
      });

      if(match)
      {
        var index = this.presets.indexOf(match);

        this.presets.splice(index, 1)
      }
    },
    getRoleName(id)
    {
      var match = this.allRoles.find(function(element) {
        return element.value === id
      });

      if(match)
      {
        return match.text
      }

      return '(unknown)'
    },
    generateUUID() { // Public Domain/MIT https://stackoverflow.com/questions/105034/create-guid-uuid-in-javascript
    var d = new Date().getTime()// Timestamp
    var d2 = (performance && performance.now && (performance.now()*1000)) || 0// Time in microseconds since page-load or 0 if unsupported
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = Math.random() * 16// random number between 0 and 16
        if(d > 0){// Use timestamp until depleted
            r = (d + r)%16 | 0
            d = Math.floor(d/16)
        } else {// Use microseconds since page-load if supported
            r = (d2 + r)%16 | 0
            d2 = Math.floor(d2/16)
        }
        return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16)
    });
    },
  },
}
</script>

<template src="./paladin-group-protected-properties.html"></template>
